export default function sliceText(text, start, end) {
  return text.length <= end ? text.slice(start, end) : text.slice(start, end) + '...';
}
